/**
 * UI dùng chung cho filter bar Matching P-S.
 *
 * `matchingRangeDateFieldSx` — size + format chuẩn cho MỌI cặp Date From-to
 * trong module Matching P-S, follow control "Shipment Period:" ở Sale Contract
 * (`compactInputSx` trong SaleContractPage). Width đủ rộng để hiện trọn
 * `DD-MMM-YYYY` (fix lỗi ngày bị che ở các ô hẹp). Áp vào `slotProps.textField.sx`
 * của DatePicker; KHÔNG đổi label/bố cục — chỉ đồng bộ kích thước + font.
 */
import type { SxProps, Theme } from '@mui/material/styles'

export const matchingRangeDateFieldSx: SxProps<Theme> = {
  width: { xs: 140, sm: 152 },
  '& .MuiInputBase-root': { minHeight: 26, fontSize: '0.72rem' },
  '& .MuiInputBase-input': { py: 0.25, px: 0.75 },
  '& .MuiInputLabel-root': { fontSize: '0.78rem' },
}
